import React from 'react';

interface DashboardSectionAnchorProps {
  sectionId: string;
  children: React.ReactNode;
  className?: string;
}

const DashboardSectionAnchor: React.FC<DashboardSectionAnchorProps> = ({
  sectionId,
  children,
  className = '',
}) => (
  <div
    id={`section-${sectionId}`}
    className={`dashboard-section-anchor ${className}`.trim()}
  >
    {children}
  </div>
);

export default DashboardSectionAnchor;
